import { IWprModeBool } from '../inter/IWprModeBool';
import { WprBaseValueModeSetter } from './WprBaseValueModeSetter';
import { IWprConfigModeOption } from '../inter/IWprConfigModeOption';
import { WprBaseViewMode } from '../WprBaseViewMode';

/**
 * モード必須設定
 */
export class WprHissuModeSetter extends WprBaseValueModeSetter<IWprModeBool> {
	// コンストラクタ  -----------------------------------------------------------
	public constructor(option: IWprConfigModeOption, viewMoode: WprBaseViewMode) {
		super('hissu', option, viewMoode);
	}
	// --------------------------------------------------------------------------

	// override メソッド	-----------------------------------------------------
	/**
	 * 初期化処理
	 * @param option モード定義オプション
	 */
	public initialize(): void {
		this.initializeModeList(this.option.hissu);
	}

	/**
	 * コントロールステータス設定処理
	 * @param vinfo 値情報
	 */
	public setControlStatus(vinfo: IWprModeBool): void {
		this.controlInfo.status.hissu = vinfo.value;
	}
	// --------------------------------------------------------------------------
}
